
import TasksAPIService from '@/modules/tasks/services/apiService'
import ReportView  from '@/modules/reporting/views/report.vue'

export default class TasksModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.tasksService = new TasksAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      // Task Manager
      {
        path: '/tasks',
        name: 'TaskManager',
        component: () => import('@/modules/tasks/views/taskManager.vue'),
        props: {
          isDeliveryManager: false,
          isPickupManager: false
        },
        meta: {
          requiresAuth: true,
          title: 'Task Manager',
          menuLink: '/tasks',
          breadcrumbs: [
            { title: 'Home', link: '/'}
          ],
        }
      },

      // Resource Group
      {
        path: '/tasks/resourcegroups/:id',
        name: 'ResourceGroup',
        component: () => import('@/modules/tasks/views/resourceGroup.vue'),
        meta: {
          requiresAuth: true,
          title: 'Resource Group',
          menuLink: '/tasks/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Tasks Configuration', link: '/tasks/configuration'},
          ],
        }
      },
      // Resource
      {
        path: '/tasks/resources/:id',
        name: 'Resource',
        component: () => import('@/modules/tasks/views/resource.vue'),
        meta: {
          requiresAuth: true,
          title: 'Resource',
          menuLink: '/tasks/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Tasks Configuration', link: '/tasks/configuration'},
          ],
        }
      },

      // Configuration
      {
        path: '/tasks/configuration',
        name: 'TaskConfiguration',
        component: () => import('@/modules/tasks/views/tasksConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Tasks Configuration',
          menuLink: '/tasks/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },

      // Task
      {
        path: '/tasks/:id(\\d+)',
        name: 'Task',
        component: () => import('@/modules/tasks/views/task.vue'),
        meta: {
          requiresAuth: true,
          title: 'Task',
          menuLink: '/tasks',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Task Manager', link: '/tasks/taskmanager'}
          ],
        }
      },

      // Task - RunSheet
      {
        path: '/tasks/:id/runsheet',
        name: 'TaskRunSheet',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Task Runsheet',
          layout: 'Blank',
          report: {
            url: '/reporting/tasks/:id/runsheet',
            variables: ['id']
          },
        }
      },
      // Task - Customer Summary
      {
        path: '/tasks/:id/customersummary',
        name: 'TaskCustomerSummary',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Task Customer Summary',
          layout: 'Blank',
          report: {
            url: '/reporting/tasks/:id/customersummary',
            variables: ['id']
          },
        }
      },
      // Task - Pending Panels
      {
        path: '/tasks/:id/pendingpanels',
        name: 'TaskPendingPanels',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Task Pending Panels',
          layout: 'Blank',
          report: {
            url: '/reporting/tasks/:id/pendingpanels',
            variables: ['id']
          },
        }
      },
    ]
  }
}
